<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:sla_status="{ item }">
        <div class="d-flex align-center">
          <StatusBadge
            :status="item.sla_status"
            :text="item?.sla_status"
          />
        </div>
      </template>

      <template v-slot:departure_geofence_name="{ item }">
        <div class="geofence-col">
          <span class="name">{{ item?.departure_geofence_name || '-' }}</span>
          <span class="eta">{{ item?.event_time || '-' }}</span>
        </div>
      </template>

      <template v-slot:next_destination="{ item }">
        <div class="geofence-col">
          <span class="name">{{ item?.next_destination || '-' }}</span>
          <span class="eta">ETA: {{ item?.next_destination_eta || '-' }}</span>
        </div>
      </template>
      <template v-slot:last_destination="{ item }">
        <div class="geofence-col">
          <span class="name">{{ item?.last_destination || '-' }}</span>
          <span class="eta">ETA: {{ item?.last_destination_eta || '-' }}</span>
        </div>
      </template>

      <template v-slot:live_location="{ item }">
        <div
          class="live_location-col"
          @click="openLiveLocation(item)"
        >
          <v-icon>mdi-map-marker</v-icon>
          <div>
            <span class="name">{{ item?.lat || '-' }}</span>
            <span class="eta">{{ item?.lng || '-' }}</span>
          </div>
        </div>
      </template>
      
     

      <!-- add Filters -->
      <template #addFilters>
        <v-card>
          <v-autocomplete
            v-model="customFilters.vendor_id"
            filled
            dense
            :loading="isVendor"
            :items="vendorList"
            item-text="child_tenant_name"
            item-value="child_tenant"
            :label="$t('select_vendor')"
            clearable
            @change="onVendorChange"
          />
        </v-card>
        <v-card>
          <v-autocomplete
            v-model="customFilters.route_id"
            filled
            dense
            :loading="isRoute"
            :items="routeList"
            item-text="name"
            item-value="id"
            :label="$t('select_route')"
            clearable
            @change="onRouteChange"
          />
        </v-card>
        <v-card class="allVehicleSelect">
          <v-autocomplete
            v-model="customFilters.vehicle_ids"
            filled
            dense
            :loading="isVehicle"
            :items="vehicleList"
            item-text="name"
            item-value="id"
            :label="$t('select_vehicles')"
            clearable
            multiple
            @change="fetchData"
          >
            <template v-slot:selection="data">
              <span
                v-if="data.index === 0"
                class="selected"
              >
                <span>{{ data.item.name }}</span>
              </span>
              <span
                v-if="data.index === 1"
                class="grey--text text-caption"
              >
                (+{{ customFilters.vehicle_ids.length - 1 }} others)
              </span>
            </template>
          </v-autocomplete>
        </v-card>
        <v-card>
          <v-autocomplete
            v-model="customFilters.sla_status"
            filled
            dense
            :loading="isLoading"
            :items="[
              { id: 'all', name: 'All' },
              { id: 'on_time', name: 'On Time' },
              { id: 'delayed', name: 'Delayed' },
              { id: 'critical', name: 'Critical' },
            ]"
            item-text="name"
            item-value="id"
            :label="$t('status')"
            clearable
            @change="fetchData"
          />
        </v-card>
      </template>
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <template #actionModals>
        <div>
          <VehiclePositionModal 
            v-if="isModal"
            :is-visible-dialog="isModal"
            :position="selectedPoints"
            :toggle-modal="toggleModal"
          />
        </div>
      </template>
      <!-- Action Modals -->

      <!-- Description -->
      <template #description>
        <div>
          <arrival-cards :loading="isLoading" />
        </div>
      </template>
      <!-- Description -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    ArrivalCards: () => import("./utlis/ArrivalCards.vue"),
    StatusBadge: () => import("@/components/base/Status-Badge.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
    VehiclePositionModal: () => import("@/components/sections/VehiclePositionModal.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      
      permissions: {
        view: "charge-stations.view",
        create: "charge-stations.create",
        edit: "charge-stations.edit",
        delete: "charge-stations.delete",
      },
      filters: {},
      subFilters: {},

      //
      customFilters: {},
      //
      isModal: false,
      selectedPoints: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "arrivalDashboard/getLoading",
      meta: "arrivalDashboard/getMeta",
      list: "arrivalDashboard/getList",
      // 
      isVendor: "tenantsRelationship/getLoading",
      vendorList: "tenantsRelationship/getList",
      //
      isRoute: "geofence/getLoading",
      routeList: "geofence/getRouteList",
      //
      isVehicle: "vehicles/getIsLoadingVehicles",
      vehicleList: "vehicles/getVehiclesList",
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("route_name"),
          align: "left",
          sortable: true,
          value: "route_name",
        },
        {
          text: this.$t("vehicle_name"),
          align: "left",
          sortable: true,
          value: "vehicle_name",
        },
        {
          text: this.$t("reg_no"),
          align: "left",
          sortable: true,
          value: "registration_no",
        },
        // {
        //   text: this.$t("tenant_name"),
        //   align: "left",
        //   sortable: false,
        //   value: "tenant_name",
        //   showAdmin: true,
        // },
        {
          text: this.$t("departure_geofence"),
          align: "left",
          sortable: false,
          value: "departure_geofence_name",
        },
        {
          text: this.$t("next_geofence"),
          align: "left",
          sortable: false,
          value: "next_destination",
        },
        {
          text: this.$t("final_geofence"),
          align: "left",
          sortable: false,
          value: "last_destination",
        },
        {
          text: this.$t("live_location"),
          align: "left",
          sortable: false,
          value: "live_location",
        },
       
        {
          text: this.$t("status"),
          align: "left",
          sortable: false,
          value: "sla_status",
        },
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return [];
    },
    
  },
   watch: {
    "options.tenant_id": {
      handler: function (v) {
        this.customFilters = {};
        this.onTenantChange({ tenant_id: v });
      },
    },
    "options.fleetId": {
      handler: function (v) {
        this.customFilters = {};
        this.onTenantChange({ tenant_id: v });
      },
    },
    customFilters:{
      handler: function () {
        this.options.page= 1;
      },
    },
    options() {
      this.fetchData();
    },
  },
  mounted() {
    setTimeout(() => {
      const tId = this.options?.tenant_id || this.options?.fleetId;
      this.onTenantChange({ tenant_id: tId });
      //
      if (this.$route?.query?.vendor_id) {
        this.customFilters.vendor_id = parseInt(this.$route?.query?.vendor_id);
        this.onVendorChange(this.customFilters.vendor_id);
      }
      if (this.$route?.query?.route_id) {
        this.customFilters.route_id = parseInt(this.$route?.query?.route_id);
        this.onRouteChange(this.customFilters.route_id);
      }
      if (this.$route?.query?.vehicle_ids) {
        this.customFilters.vehicle_ids = this.$route?.query?.vehicle_ids?.map(
          (r) => parseInt(r)
        );
        this.onVehicleChange(this.customFilters.vehicle_ids);
      }
    }, 500);
  },
  beforeDestroy() {
    const params = {
      name: "arrival_dashboard",
      filters: { ...this.options, ...this.customFilters },
    };
    // delete params?.filters?.date;
    // delete params?.filters?.dateType;
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    openLiveLocation(item) {
        this.selectedPoints = {
          lat: item.lat,
          lng: item.lng,
        };
        this.isModal = true;
      },
    toggleModal() {
      this.isModal = !this.isModal;
    },
    fetchData() {
      this.getAggregatedData();
      this.getList();
    },
    getAggregatedData: debounce(async function () {
      const params = { ...this.options, ...this.customFilters };
      await this.$store.dispatch("arrivalDashboard/aggregattedData", params);
    }, 1500),
    getList: debounce(async function () {
      const params = { ...this.options, ...this.customFilters };
      await this.$store.dispatch("arrivalDashboard/list", params);
    }, 1500),

    onTenantChange(params) {
      this.getVendorList(params);
      this.getRouteList(params);
      this.getVehicleList(params);
    },
    //
    getVendorList: debounce(async function (params) {
      await this.$store.dispatch("tenantsRelationship/list", {
        parent_tenant_id: params?.tenant_id,
      });
    }, 500),
    getRouteList: debounce(async function (params) {
      await this.$store.dispatch("geofence/routeList", params);
    }, 500),
    getVehicleList: debounce(async function (params) {
      await this.$store.dispatch("vehicles/list", {
        ...params,
        compare_route: true,
      });
    }, 500),
    //
    onVendorChange(v) {
      delete this.customFilters.route_id;
      delete this.customFilters.vehicle_ids;

      const params = { tenant_id: v };
      this.getRouteList(params);
      this.getVehicleList(params);
      this.fetchData();
    },
    onRouteChange(v) {
      delete this.customFilters.vehicle_ids;
      const params = { route_id: v, tenant_id: this.customFilters.vendor_id };
      this.getVehicleList(params);
      this.fetchData();
    },

    // goTo(path) {
    //   const params = { ...this.options };
    //   if (params.dateType === "custom") {
    //     params.dateRange = params.date;
    //     delete params.date;
    //   }
    //   return { name: path, query: params };
    // },

    // goToDetail() {
    //   this.$router.push('/operations-troubleshooting/detail');
    // },
  },
};
</script>
<style scoped>
.row-box-wrap {
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 10px;
  /* Adds space between items */
}

.text-muted {
  color: #6c757d;
}

.highlighted {
  font-weight: bold;
}

.copy-button {
  margin-left: auto;
  /* Pushes the button to the far right */
}

.geofence-col {
  display: flex;
  flex-direction: column;
}

.geofence-col .name {
  font-weight: 600;
}
.geofence-col .eta {
  font-size: 12px;
  color: #6c757d;
}
</style>
<style lang="sass" scoped>
.live_location-col
  display: flex
  align-items: center
  gap: 0.5rem
  cursor: pointer
  &:hover
    color: green
    i
      color : #20a390

  >div
    display: flex
    flex-direction: column
</style>